import { getLineTypeFeatures, Line, LineGeoJsonFeature } from '@/services/lines.service'

export async function addLineFeaturesForType(
  coreId: string,
  categoryId: string,
  typeId: string,
  existingLinesArray: LineGeoJsonFeature[]
): Promise<LineGeoJsonFeature[] | null> {
  const lineFeaturesForType = await getLineTypeFeatures(coreId, categoryId, typeId)
  if (!lineFeaturesForType) return null
  return existingLinesArray.concat(lineFeaturesForType)
}
export function setExistingLineDataVisibility(
  typeId: string,
  checked: boolean,
  filteredLines: Line[]
): void {
  filteredLines.forEach((layer) => {
    layer.types.forEach((type) => {
      if (type.id === typeId) {
        type.visible = checked
        layer.visible =
          layer.types.filter((type) => type.visible === true).length === layer.types.length
      }
    })
  })
}
export function setNewLineDataVisibility(
  categoryId: string,
  typeId: string,
  checked: boolean,
  filteredLines: Line[]
): void {
  const lineCategory = filteredLines.find((layer) => layer.id === categoryId)
  const lineTypeInfo = lineCategory?.types.find((type) => type.id === typeId)
  if (lineTypeInfo) lineTypeInfo.visible = checked
  if (lineCategory)
    lineCategory.visible =
      lineCategory?.types.filter((type) => type.visible === true).length ===
      lineCategory?.types.length
}
